<template>
    <div>
        <base-header type="gradient-info" class="pb-6 pb-8 pt-4 pt-md-7">
            <div class="row mb-2">
            </div>
        </base-header>
        <div class="container-fluid mt--7 mb-5">
            <div class="row mb-3">
                <div class="col-lg-12 mb-3">
                    <card shadow>
                        <div slot="header" class="bg-white border-0">
                            <div class="row">
                                <div class="col-lg-6">
                                    <h3 class="mb-0">ยกเว้นค่าขนส่งในใบแจ้งหนี้</h3>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="card-body">
                                    <div class="row justify-content-md-center py-md-3">
                                        <div class="col-lg-12">
                                            <h6 class="heading-small text-muted mb-3">กรอกหมายเลขพัสดุ</h6>
                                            <form @submit.prevent="waiveInvoiceUnpaid()">
                                                <div class="form-group">
                                                    <b-form-textarea
                                                        v-model="invoice.trackingCode"
                                                        class="form-control"
                                                        placeholder="ตัวอย่างการกรอกหมายเลขพัสดุ TH123456789,EX123456789,QFX123456789"
                                                        rows="6"
                                                        max-rows="6"
                                                    ></b-form-textarea>
                                                </div>
                                            </form>
                                        </div>
                                        <div class="col-lg-12 text-center">
                                            <b-button 
                                                variant="primary" 
                                                class="m-1 px-5"
                                                @click="waiveInvoiceUnpaid()"
                                                :disabled="!invoice.trackingCode"
                                            >
                                                <i class="fas fa-circle-notch fa-spin" v-if="invoice.isLoading"></i>
                                                ค้นหา
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { waiveInvoice } from '@/axios/invoice'
import { showSuccessModal , showErrorModal } from "@/components/modalNotification.js";

export default {
    data: () => ({
        invoice:{
            isLoading: false,
            trackingCode: ''
        }
    }),
    methods: {
        waiveInvoiceUnpaid(){
            let tracking = this.invoice.trackingCode.split(",");
            waiveInvoice(tracking).then(res => {
                if( res.success ){
                    showSuccessModal( `ยกเว้นค่าขนส่งหมายเลขพัสดุ ${tracking} เสร็จเรียบร้อย` )
                }
                
            }).catch( (error) => {
                showErrorModal( error )
            })
        }
    },
}
</script>